<template>
  <v-layout fill-height column>
    <v-container flex-fill>
      <!-- 훈련형 -->
      <div class="breath-content fill-width fill-height">
        <div class="content" v-if="training">
          <div class="time">00:00</div>
          <div :class="[{'pause':pause},'breath']"><span></span><span></span></div>
          <v-btn icon @click="pauseClick" class="control">
            <Pause :pause="pause" />
          </v-btn>
        </div>
        <!-- 완료 -->
        <div v-else class="pos-center d-flex justify-center align-center">
          <CompleteCheck />
          <span class="fs-31 fw-400 white--text ms-3">완료</span>
        </div>
        <!-- 배경은 메인에서 처리 -->
        <v-img :src="'https://i.pinimg.com/564x/48/1a/24/481a24851ac8c58a94cf3151e0ba7ae9.jpg'" width="100vw" height="calc(var(--vh, 1vh) * 100)"
               class="pos-absolute" />
      </div>
    </v-container>
  </v-layout>
</template>
<script>
import Pause from "@/components/icons/Pause"
import CompleteCheck from "@/components/icons/CompleteCheck"

export default {
  props: {
    current: Number,
    total: Number,
  },
  data: () => ({
    pause: false,
    training: true, /* 트레이닝 중인지.. */
  }),
  components: {
    Pause,
    CompleteCheck
  },
  computed: {},
  methods: {
    pauseClick() {
      this.pause = !this.pause;
    }
  },

}
</script>
